// Where the primitives' portals go when a caller names no container (T4b demo, after E09-S7-T1).
// The Surface root provides its own element, so a menu, a tooltip or a dialog opens inside the
// surface — inside a shadow root when the surface is mounted in one (the overlay root, E05-S6-T2) —
// and never in the observed page's body. Without a provider, document.body holds (the gallery, a
// page the surface owns).
import { createContext, useContext } from "react";
/** The Surface root's element; null until it has mounted; undefined outside any Surface root. */
export const PortalContainer = createContext(undefined);
/**
 * The container a portal uses: the caller's own, else the provided one, else document.body. Null
 * while a provided root has not mounted yet: the portal renders nothing rather than fall back to the
 * page's body.
 */
export function usePortalContainer(own) {
    const provided = useContext(PortalContainer);
    if (own)
        return own;
    if (provided !== undefined)
        return provided;
    return typeof document === "undefined" ? null : document.body;
}
//# sourceMappingURL=portal.js.map